function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Interface-Essential / Delete / delete-2"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#808f9a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "data-name": "Group 352"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Oval 263",
  d: "M12 23.5A11.5 11.5 0 1 0 .5 12 11.5 11.5 0 0 0 12 23.5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape 1812",
  d: "M7 7l10 10"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape 1813",
  d: "M17 7L7 17"
})));

const SvgCrossSymbol = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: 24,
  height: 24
}, props), _ref);

export default SvgCrossSymbol;